import React from "react";

const DeliveryOption = ({
  value,
  selected,
  onChange,
  title,
  subtitle,
  icon,
  disabled = false,
}) => {
  const isActive = selected === value;

  return (
    <div
      onClick={() => !disabled && onChange(value)}
      style={{
        border: isActive ? "2px solid #198754" : "1px solid #e5e7eb",
        backgroundColor: isActive ? "#f8fafc" : "#f9fafb",
        borderRadius: "12px",
        padding: "16px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: "12px",
        transition: "all 0.2s ease",
      }}
    >
      <div>{icon}</div>

      <div>
        <div style={{ fontWeight: "600" }}>{title}</div>
        <div style={{ fontSize: "12px", color: "#6b7280" }}>{subtitle}</div>
      </div>
    </div>
  );
};

export default DeliveryOption;
